module.exports = __webpack_public_path__ + "static/media/aeroplane-aircraft-airplane-svgrepo-com.f11b35a8.svg";